/* app/events.js
Bento Box Utils Module
*/

import $ from 'jquery';
import _ from 'underscore';
import He from 'he';
import Masonry from 'masonry-layout';


// Utility object for handling the Masonry layout
// NOTE: For right now all updates to the layout simply regenerate the
// masonry object. This is the way it must be done because re-rendering
// bento box elements does not update them in place, it removes the old
// one from the DOM and replaces it with a new one. When it does this, the
// new elements are not part of the previously created Masonry object, so
// calling 'masonry.layout()' does not update them. A whole new object
// must be created that includes the new DOM elements.
export let layout = {
  selector: '#masonryContainer',
  jumpToElementId: null,

  update: function() {
    if ($(this.selector).length) {
      this.masonry = new Masonry(this.selector, {
        percentPosition: true,
        horizontalOrder: true,
        transitionDuration: 0
      });
    }
  },

  jumpToElement: function(elementId) {
    if (elementId) {
      this.jumpToElementId = elementId;
    }
    if (this.jumpToElementId) {
      const jumpToElement = document.getElementById(this.jumpToElementId);
      if (jumpToElement) {
        jumpToElement.scrollIntoView();
      }
    }
  },
};

// Utility function that translates a Discover resource type phrase
// into font-awesome classes. It works by normalizing the resource type
// (converting to lowercase, stripping ending parentheticals) and
// breaking apart words. It uses the 'wordMap' structure to read words
// recursively and then select the first thing that matches. The '_'
// entry represents a stopping point, where it returns that set of FA
// classes.
export function getTypeInfo(vars) {
  let label = (
    vars.format == 'Online' ? 'E-Journal' : (
      vars.format == 'Print' ? 'Journal (Print/Paper)' : undefined
    )
  ) || vars.type || '';
  let defaultCls = vars.externalLink ? 'fa fa-link' : 'fa fa-cube';
  let words = label.replace(/\s*\(.*?\)$/, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, ' ')
    .split(' ');
  let wordsMap = {
    'archival': {'_': 'fa fa-archive'},
    'audio': {'_': 'fa fa-compact-disc'},
    'book': {'_': 'fa fa-book'},
    'computer': {
      'program': {'_': 'fa fa-code'},
    },
    'digital': {
      'file': {'_': 'fa fa-file'},
      '_': 'fa fa-code',
    },
    'e': {'_': 'fa fa-tablet-android-alt'},
    'filmstrip': {'_': 'fa fa-film'},
    'game': {'_': 'fa fa-gamepad'},
    'graphic': {'_': 'fa fa-images'},
    'journal': {'_': 'fa fa-book'},
    'map': {'_': 'fa fa-map'},
    'manuscript': {'_': 'fa fa-archive'},
    'motion': {'_': 'fa fa-film'},
    'music': {
      'score': {'_': 'fa fa-list-music'},
      '_': 'fa fa-compact-disc',
    },
    'newspaper': {'_': 'fa fa-newspaper'},
    'online': {
      'database': {'_': 'fa fa-database'},
    },
    'slide': {'_': 'fa fa-film'},
    'streaming': {
      'audio': {'_': 'fa fa-cloud-music'},
      'music': {'_': 'fa fa-cloud-music'},
      'video': {'_': 'fa fa-video'},
    },
    'tabletop': {'_': 'fa fa-game-board'},
    'thesis': {'_': 'fa fa-book'},
    'video': {'_': 'fa fa-film'},
  };
  const _findClasses = function(mapping, words) {
    const _search = function(mapping, words) {
      let result = mapping[words[0]];
      return result ? _search(result, words.slice(1)) : mapping['_'];
    }
    return words.length ? (_search(mapping, words) || _findClasses(mapping, words.slice(1))) : defaultCls;
  }
  return {label: label, faClasses: _findClasses(wordsMap, words)};
}

// Utility function that converts a string into an actual boolean value.
// The default assumption is True.
export function strToBool(val) {
  return !_.contains([null, undefined, 'f', 'false', 'F', 'FALSE', '0'], val);
}

// Utility function that prepares a query string for display, with all
// appropriate decoding/encoding.
export function prepQueryForDisplay(q, truncate) {
  truncate = truncate || 0;
  if (q !== null) {
    q = He.encode(decodeURI(q));
    if (truncate > 0) {
      let words = q.split(' ');
      if (words.length > truncate) {
        q = words.slice(0, truncate).join(' ') + ' ... ';
      } else {
        q = words.join(' ');
      }
    }
  }
  return q;
}

// Utility function that truncates a block of text based on numeric index
// representing the point in the text at which truncation should occur. It tries
// to find the first non-word character within 10 characters after that to truncate.
export function truncateText(text, truncatePoint) {
  let i = truncatePoint;
  while (text.charAt(i).match(/\w/) && i <= i + 10) {
    i++;
  }
  return text.substring(0, i) + ' ...';
}
